import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { TabView, TabPanel } from "primereact/tabview";
import JourneyDetailData from "./journeyDetailData";
import JourneyStocksData from "./journeyStocksData";
import JourneyTeamsForm from "./journeyTeamsForm";
import ContentLayout from "../../../../../partials/content/ContentLayout";
import {
  getJourneyDetail,
  updateJourneyStatus,
} from "../../../../../services/crm/salesJourney";
import Attachments from "../../../common/attachments";
import Notes from "../../../common/notes";
import { PageSubHeader } from "../../../../../../provider/PageDataProvider";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import JourneyEditForm from "./journeyEditForm/journeyEditForm";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import { DateTime } from "luxon";
const JourneyDetail = ({ match, history }) => {
  const { reload } = useGlobalData();
  const journeyID = match.params.journeyID;
  const [openJourneyEditForm, setOpenJourneyEditForm] = useState(false);
  const [journey, setJourney] = useState({
    ID: 0,
    title: "",
    journeyStartDate: DateTime.now().startOf("day"),
    journeyEndDate: DateTime.now().endOf("day"),
    salesID: 0,
    salesName: "",
    description: "",
  });

  useEffect(() => {
    getJourneyDetailData(journeyID);
  }, [journeyID, reload]);

  const actionButtons = [
    {
      title: "",
      color: "label-brand",
      icon: "fas fa-backward",
      onClick: () => {
        history.push("/crm/sales-journey");
      },
    },
  ];
  if (journey.statusID === 1) {
    actionButtons.push({
      title: "Cancel Journey",
      color: "danger",
      icon: "fas fa-window-close",
      onClick: () => {
        updateJourneyStatusConfirm(9, "cancel");
      },
    });
    actionButtons.push({
      title: "Start Journey",
      color: "primary",
      icon: "fas fa-flag",
      onClick: () => {
        updateJourneyStatusConfirm(2, "start");
      },
    });
  }
  if (journey.statusID === 2) {
    actionButtons.push({
      title: "Finish Journey",
      color: "success",
      icon: "fas fa-flag-checkered",
      onClick: () => {
        updateJourneyStatusConfirm(3, "finish");
      },
    });
  }

  if (journey.statusID < 3) {
    actionButtons.push({
      title: "Edit Journey",
      color: "primary",
      icon: "fas fa-edit",
      onClick: () => {
        setOpenJourneyEditForm(true);
      },
    });
  }

  return (
    <React.Fragment>
      <PageSubHeader
        title="Sales Journey"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/crm/sales-journey",
            title: "Sales Journeys",
            active: false,
          },
          {
            page: "/crm/journey-detail/" + journey.ID,
            title: "Sales Journey ID " + journey.ID + " " + journey.title,
            active: true,
          },
        ]}
        actionButtons={actionButtons}
      />
      <ContentLayout>
        <div className="tabview">
          <div className="card">
            <TabView className="tabview" scrollable>
              <TabPanel header="Sales Journeys" rightIcon="fas fa-route">
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <JourneyDetailData
                      journey={journey}
                      history={history}
                      onReloadJourney={() => {
                        getJourneyDetailData(journeyID);
                      }}
                    />
                  </div>
                </div>
              </TabPanel>
              <TabPanel header="Teams" rightIcon="fas fa-user-friends">
                <JourneyTeamsForm journey={journey} />
              </TabPanel>
              <TabPanel header="Stocks" rightIcon="fas fa-boxes">
                <JourneyStocksData journey={journey} />
              </TabPanel>
              <TabPanel header="Attachments" rightIcon="fas fa-paperclip">
                <Attachments docType="SLJO" docID={journey.ID} />
              </TabPanel>
              <TabPanel header="Notes" rightIcon="fas fa-sticky-note">
                <Notes docType="SLJO" docID={journey.ID} />
              </TabPanel>
            </TabView>
          </div>
        </div>
      </ContentLayout>
      <DialogLayout
        open={openJourneyEditForm}
        title="Edit Sales Journey"
        onCloseDialog={() => {
          setOpenJourneyEditForm(false);
        }}
        maxWIdth="md"
      >
        <JourneyEditForm
          journey={journey}
          onConfirmSave={() => {
            getJourneyDetailData(journeyID);
            setOpenJourneyEditForm(false);
          }}
          onCloseDialog={() => {
            setOpenJourneyEditForm(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );
  function updateJourneyStatusConfirm(statusID = 0, action = "") {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to " + action + " this Sales Journey ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText:
          `<i class="fas fa-check-circle"></i> Yes, ` + action + ` it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          const journeyUpdate = { ...journey };
          journeyUpdate.statusID = statusID;
          updateJourneyStatus(journeyUpdate).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Saved",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            getJourneyDetailData(journeyID);
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }

  async function getJourneyDetailData(journeyID) {
    const response = await getJourneyDetail(journeyID);
    const { data } = response.data;
    setJourney(data.salesJourney);
  }
};

export default JourneyDetail;
